import i18n from "../plugins/locale/i18n";
import loadDictionary from "../plugins/locale/load-dictionary";

await loadDictionary('menu');

export default [
    {
        "title": i18n.t("menu.group_payment"),
        "items": [
            {
                "icon": "bi-receipt-cutoff",
                "section": "payment_order_list_page",
                "title": i18n.t("menu.payment_orders"),
                "description": i18n.t("menu.payment_orders_desc"),
                "url": "/payment-orders"
            },
            {
                "icon": "bi-bank",
                "section": "bank_account_list_page",
                "title": i18n.t("menu.bank_accounts"),
                "description": i18n.t("menu.bank_accounts_desc"),
                "url": "/bank-accounts"
            },
            {
                "icon": "bi-diagram-3",
                "section": "party_list_page",
                "title": i18n.t("menu.parties"),
                "description": i18n.t("menu.parties_desc"),
                "url": "/parties"
            }
        ]
    },
    {
        "title": i18n.t("menu.group_cards"),
        "items": [
            {
                "icon": "bi-credit-card",
                "section": "bank_account_bon_cards",
                "title": i18n.t("menu.cards"),
                "description": i18n.t("menu.cards_desc"),
                "url": "/bank-accounts/bon-cards"
            },
            {
                "icon": "bi-arrow-repeat",
                "section": "bank_account_bon_card_receipts",
                "title": i18n.t("menu.card_diff_transaction"),
                "description": i18n.t("menu.card_diff_transaction_desc"),
                "url": "/bank-accounts/bon-card-receipts"
            }
        ]
    },
    {
        "title": i18n.t("menu.group_system"),
        "items": [
            {
                "icon": "bi-grid-3x3-gap",
                "section": "api_app_list_page",
                "title": i18n.t("menu.apps"),
                "description": i18n.t("menu.apps_desc"),
                "url": "/api-apps"
            }
        ]
    },
    {
        "title": i18n.t("menu.group_reports"),
        "items": [
            {
                "icon": "bi-box-arrow-in-down-left",
                "section": "bank_account_statements_page",
                "title": i18n.t("menu.bank_account_statements"),
                "description": i18n.t("menu.bank_account_statements_desc"),
                "url": "/bank-accounts/statements"
            },
            {
                "icon": "bi-box-arrow-in-down-left",
                "section": "inbound_request_log_list_page",
                "title": i18n.t("menu.inbound_logs"),
                "description": i18n.t("menu.inbound_logs_desc"),
                "url": "/inbound-request-logs"
            },
            {
                "icon": "bi-box-arrow-up-right",
                "section": "outbound_request_log_list_page",
                "title": i18n.t("menu.outbound_logs"),
                "description": i18n.t("menu.outbound_logs_desc"),
                "url": "/outbound-request-logs"
            }
        ]
    },
    {
        "title": i18n.t("menu.group_users"),
        "items": [
            {
                "icon": "bi-people",
                "section": "user_list_page",
                "title": i18n.t("menu.users"),
                "description": i18n.t("menu.users_desc"),
                "url": "/users"
            },
            {
                "icon": "bi-shield-check",
                "section": "role_list_page",
                "title": i18n.t("menu.roles"),
                "description": i18n.t("menu.roles_desc"),
                "url": "/roles"
            }
        ]
    }
];